/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useCallback } from 'react';
import {
  arrayOf,
  func,
  number,
  shape,
  string
} from 'prop-types';

import { useIsMobile } from '../../../hooks/use-is-mobile';
import { RebateLocation } from '../rebate-location/RebateLocation';
import { RebateFilterButton } from '../rebate-filter-button/RebateFilterButton';
import { RebateSearchBar } from '../rebate-search-bar/RebateSearchBar';
import { ResultCount } from './subcomponents/result-count/ResultCount';

export const RebateSearchAndFilter = ({
  filterOptions,
  filterData,
  setFilterData,
  localAreaData,
  setLocalZip,
  totalItemCount
}) => {
  const { isMobile } = useIsMobile();

  const onSearch = useCallback((searchInput) => {
    setFilterData((prev) => ({ ...prev, searchedItem: searchInput }));
  }, [setFilterData]);

  const hasFilters = Boolean(filterData.searchedItem || Object.keys(filterData.appliedFilters).length);

  return (
    <div className="sui-bg-primary sui-mb-[15px] sui-p-[20px]">
      <div className="sui-flex sui-justify-between sui-flex-row sui-flex-wrap">
        <RebateSearchBar
          value={filterData.searchedItem}
          onSearch={onSearch}
        />
        {hasFilters && <ResultCount count={totalItemCount} />}
        <RebateLocation
          localAreaData={localAreaData}
          setLocalZip={setLocalZip}
        />
      </div>
      <RebateFilterButton
        filterOptions={filterOptions}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </div>
  );
};

RebateSearchAndFilter.propTypes = {
  filterOptions: arrayOf(shape({})).isRequired,
  filterData: shape({
    appliedFilters: shape({}),
    searchedItem: string
  }).isRequired,
  setFilterData: func.isRequired,
  localAreaData: shape({
    cityState: string
  }).isRequired,
  setLocalZip: func.isRequired,
  totalItemCount: number
};

RebateSearchAndFilter.defaultProps = {
  totalItemCount: null
};

RebateSearchAndFilter.displayName = 'RebateSearchAndFilter';
